import React from 'react';
import classes from './PublicSurveys.module.scss';
import useTranslate from '../../../hooks/useTranslate';
import ItemList from '../../molecules/ItemList/ItemList';
import { PropSurveyItem } from '../../molecules/SurveyItem/SurveyItem';
import { useStaticSurveys } from './useStaticSurveys';

export interface Props {}

const PublicSurveys: React.FC<Props> = () => {
  const translate = useTranslate();
  const staticSurveys = useStaticSurveys();
  return (
    <>
      <ItemList animate>
        {staticSurveys.map((survey) => (
          <li key={survey.id}>
            <PropSurveyItem
              survey={{ ...survey, title: translate(survey.title) }}
              className={survey.url ? classes.survey : classes.disabledSurvey}
              disableTooltip
            />
          </li>
        ))}
      </ItemList>
    </>
  );
};

export default PublicSurveys;
